import React from 'react'
import ProptType from 'prop-types'
import { codeFormat, cupomQttFormat, currencyFormat } from 'utils/format'
import { Separator } from '../../styles'
import {
  Item,
  FirstLine,
  SecondLine,
} from './styles'

export default function Items({ ordersPaymentItems }) {
  const renderItem = (orderItem, index) => (
    <Item className="item-info">
      <FirstLine>
        <div>
          {index + 1}
        </div>
        <div>
          {codeFormat(orderItem.item.code)}
        </div>
        <div>
          {orderItem.item.name}
        </div>
      </FirstLine>
      <SecondLine>
        <div>
          {cupomQttFormat(orderItem.quantity)}
        </div>
        <div>
          {orderItem.item.unit}
        </div>
        <div className="value">
          {currencyFormat(orderItem.value)}
        </div>
        <div className="value">
          {currencyFormat(orderItem.total_value)}
        </div>
      </SecondLine>
    </Item>
  )

  const renderOrderItems = (orderPaymentItem) => (
    orderPaymentItem.order.items.map((item, index) => renderItem(item, index))
  )

  return ordersPaymentItems?.length ? (
    <>
      <Item>
        <FirstLine>
          <div>It</div>
          <div>Codigo</div>
          <div>Descricao do Produto</div>
        </FirstLine>
        <SecondLine>
          <div>Qtde</div>
          <div>Unid</div>
          <div>Valor R$</div>
          <div>Total R$</div>
        </SecondLine>
      </Item>

      <Separator />
      { ordersPaymentItems.map(renderOrderItems) }
    </>
  ) : null
}

Items.propTypes = {
  ordersPaymentItems: ProptType.arrayOf(ProptType.object),
}

Items.defaultProps = {
  ordersPaymentItems: [],
}
